export default __webpack_public_path__ + "static/media/ryanqiu1.cc1a3d62.jpg";